export default "__VITE_ASSET__6cd5dec0__"